import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth';
import LefPaneImage from '../images/Login Page.jpg';
import logo from '../images/Godrej_Logo.png';
import './LoginPage.css';

import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

export default function LoginPage() {
  const { ssoLogin, login } = useAuth();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();

  // const [emailOrEmpCode, setEmailOrEmpCode] = useState('');
  // const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const from = location.state?.from?.pathname || '/';

  // Traditional login — commented out, using Azure AD SSO
  // const onSubmit = async (e) => {
  //   e?.preventDefault?.();
  //   setError('');
  //   if (!emailOrEmpCode || !password) {
  //     setError('Please enter both Email/EmpCode and Password.');
  //     return;
  //   }
  //   try {
  //     setSubmitting(true);
  //     await login(emailOrEmpCode, password);
  //     navigate(from, { replace: true });
  //   } catch (err) {
  //     setError(err?.message || 'Invalid credentials. Please try again.');
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const handleSSOLogin = async () => {
    setError('');
    try {
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      setError(err?.message || 'SSO login failed');
    }
  };

  // const inputStyle = {
  //   width: '100%',
  //   height: '50px',
  //   padding: '0 16px',
  //   border: '1.5px solid #810055',
  //   borderRadius: '8px',
  //   fontSize: '15px',
  //   fontFamily: "'GEG-BodyCopy', 'Segoe UI', sans-serif",
  //   color: '#333',
  //   background: '#fff',
  //   boxSizing: 'border-box',
  //   display: 'block',
  //   lineHeight: '50px',
  //   letterSpacing: 'normal',
  //   outline: 'none',
  //   appearance: 'none',
  //   WebkitAppearance: 'none',
  // };

  return (
    <div className="login-page">
      <header className="login-header">
        <img src={logo} alt="Godrej Logo" className="godrej-logo" />
        <span className="company-text">Godrej Enterprises Group</span>
      </header>

      <div className="login-body">
        <div className="login-image-pane">
          <img src={LefPaneImage} alt="Login visual" />
        </div>

        <div className="login-container">
          <div className="login-box">
            <div className="title-section">
              <h1 className="main-title">TSA</h1>
              <p className="sub-title">Training System Appliances</p>
            </div>

            {/* Traditional login form — commented out, using Azure AD SSO
            <form className="login-form" onSubmit={onSubmit}>
              <div className="form-group">
                <label htmlFor="emailOrEmpCode">Employee Code</label>
                <input
                  id="emailOrEmpCode"
                  className="login-input"
                  type="text"
                  placeholder="Email-ID or Employee Code"
                  value={emailOrEmpCode}
                  onChange={(e) => setEmailOrEmpCode(e.target.value)}
                  autoComplete="username"
                  style={inputStyle}
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  className="login-input"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  style={inputStyle}
                />
              </div>
              {error && <p className="error-message">{error}</p>}
              <button type="submit" className="login-btn" disabled={submitting}>
                {submitting ? 'Signing in…' : 'Login'}
              </button>
            </form>
            */}

            {error && <p className="error-message">{error}</p>}
            <button
              type="button"
              className="sso-button"
              onClick={handleSSOLogin}
              disabled={submitting}
            >
              {submitting ? 'Signing in…' : 'Sign in with Microsoft'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
